import { useState } from 'react';

import { StatusCode, PaymentStatus } from '../../../../api/enumerations';
import { changePaymentStatus } from '../../../../api/financial';
import { HivePaymentData } from '../../../../api/financial/types';
import { WhiteCircularProgress } from '../../../../components/UI/Typography';
import { Constants } from '../../../../constants/finance';
import useErrorMessage from '../../../../hooks/useErrorMessage';
import useSnackbar from '../../../../hooks/useSnackbar';
import { ActionButton } from '../../styles';
import { PaymentHeader } from '../PaymentHeader';
import { StatusStyle } from '../Table/PaymentActionButton';
import {
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ApproveDialogProps {
  paymentData: HivePaymentData;
  styles: StatusStyle;
  updateData: () => void;
}

export default function ApproveDialog({
  paymentData,
  styles,
  updateData,
}: ApproveDialogProps): JSX.Element {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const { handleSnackbar } = useSnackbar();
  const { getErrorMessage } = useErrorMessage();

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  const handleApprove = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await changePaymentStatus(paymentData.id, {
        status: PaymentStatus.APPROVED,
      });

      if (response.detail.description)
        throw new Error(response.detail.description);

      if (response.detail.status_code !== StatusCode.OK)
        throw new Error('Algo deu errado, tente novamente.');

      handleSnackbar('Pagamento aprovado com sucesso!', false);
      updateData();
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionButton
        bgcolor={styles.bg}
        textcolor={styles.color}
        onClick={handleOpen}
      >
        {Constants.approve}
      </ActionButton>
      <StyledDialog open={open} onClose={handleClose}>
        <DialogContainer>
          <PaymentHeader paymentData={paymentData} />
          <TextTypography>
            Você confirma a aprovação do pagamento?
          </TextTypography>
          <ButtonBox>
            <OutlinedButton onClick={handleClose}>
              {Constants.cancel}
            </OutlinedButton>
            <FilledButton disabled={loading} onClick={handleApprove}>
              {loading ? (
                <WhiteCircularProgress size={22} />
              ) : (
                Constants.approve
              )}
            </FilledButton>
          </ButtonBox>
        </DialogContainer>
      </StyledDialog>
    </>
  );
}
